export default "__VITE_PUBLIC_ASSET__4158369c__"